import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row", "toggle", "chevron"];
  static values = { collapsed: Boolean };

  connect() {
    this.render();
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue;
    this.render();
  }

  render() {
    this.rowTargets.forEach((row) => {
      row.hidden = this.collapsedValue;
    });
    this.toggleTarget.setAttribute("aria-expanded", String(!this.collapsedValue));
    this.chevronTarget.classList.toggle("-rotate-90", this.collapsedValue);
  }
}
